// Added by Sejune Oh on 2019-09-09
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ReqSearchPatientOriginalProps {
    target_url: string
    annoimized_id: string
    data_token: string
}

interface ResSearchPatientOriginalId {
    patient_id: string
    patient_name: string
}

export const reqSearchPatientOriginal = async ({
    target_url,
    annoimized_id,
    data_token = '',
}: ReqSearchPatientOriginalProps) => {
    const url =
        target_url.split('https://').length === 2
            ? target_url
            : target_url.split('http://').length === 2
            ? target_url
            : `http://${target_url}`
    if (data_token !== '') {
        return await axios.get<ResSearchPatientOriginalId>(
            `${url}/api/gw/find-patid?anonymized_pid=${annoimized_id}&data_token=${data_token}`
        )
    } else {
        return await axios.get<ResSearchPatientOriginalId>(`${url}/api/gw/find-patid?anonymized_pid=${annoimized_id}`)
    }
}
